module.exports = __webpack_public_path__ + "img/logout.a2b6551c.svg";